export function getValidParent(container: HTMLElement, cssClass: string): HTMLElement | undefined {
  if (!cssClass) {
    return undefined;
  }

  const parent = container.parentElement;

  if (parent) {
    if (Array.from(parent.classList).find(clss => clss.includes(cssClass))) {
      return parent;
    } else {
      return getValidParent(parent, cssClass);
    }
  }

  return undefined;
}
